import { services } from "./Services.js";
import { substitute } from "./qbo-json.js";
export class RestApiService {
    constructor(apiEndpoint, headers = {}, method = null) {
        this.basePath = '';
        this.relativePath = '';
        this.apiEndpoint = apiEndpoint;
        this.headers = headers;
        this.method = method;
        const url = new URL(this.apiEndpoint);
        this.basePath = `${url.href}`;
    }
    async fetch(relativePath, payload) {
        if (this.apiEndpoint.indexOf("//") < 0)
            this.apiEndpoint = new URL(this.apiEndpoint, document.location.origin).href;
        const endpoint = substitute(new URL(relativePath ?? this.relativePath, this.apiEndpoint).href, payload);
        const method = this.method ?? (payload ? 'POST' : 'GET');
        const headers = new Headers(this.headers || {});
        if (payload && !headers.has('Content-Type')) {
            headers.append('Content-Type', 'application/json');
        }
        const response = await fetch(endpoint, {
            method: method,
            headers: headers,
            credentials: 'include',
            body: (method === 'POST' && payload) ? JSON.stringify(payload) : null
        });
        const accept = headers.get("Accept") ?? '';
        if (response.ok) {
            switch (accept) {
                case "application/json":
                    return await response.json();
                default:
                    return await response.text();
            }
        }
        console.error(`API request failed with status ${response.status}`);
        return null;
    }
    clone(relativePath) {
        const clone = new RestApiService(this.apiEndpoint, this.headers, this.method);
        clone.relativePath = relativePath ?? '';
        return clone;
    }
}
// Register a RestApiService with the default name 'default' and the base URL of the current page
services.container.registerInstance('default', new RestApiService(document.querySelector('base[href]')?.getAttribute('href') || window.location.origin));
// Sugar for registering a RestApiService with registerRestApi('myName', 'https://my.api.com')
export function registerRestApi(name, apiEndpoint, headers = { 'Content-Type': 'application/json' }, method) {
    services.container.registerInstance(name, new RestApiService(apiEndpoint, headers, method));
}
export function getApiService(url) {
    if (typeof url !== 'string') {
        url = url.href;
    }
    const parts = url.match(/api:\/\/([^/]+)/);
    const name = parts ? parts[1] : url;
    const relativePath = parts ? url.substring(`api://${name}`.length + 1) : '';
    const service = services.container.isRegistered(name)
        ? services.container.resolve(name)
        : new RestApiService(url);
    return (relativePath) ? service.clone(relativePath) : service;
}
